import { render } from "./BlogList.vue?vue&type=template&id=e98aa51e&scoped=true"
import script from "./BlogList.vue?vue&type=script&lang=js"
export * from "./BlogList.vue?vue&type=script&lang=js"

import "./BlogList.vue?vue&type=style&index=0&id=e98aa51e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e98aa51e"]])

export default __exports__